<template>
  <div class="ims-standings" v-if="race">{{race.name}} standings</div>
  <div v-else>
    Unable to load
    <strong>{{$User.profile.teamName}}'s</strong> rank for this race
  </div>
</template>

<script>
// /api/league/details?leagueId=X&limit=3&top=50&raceId=123?
export default {
  data() {
    return {
      race: null
    };
  },
  props: {
    raceId: Number,
    leagueId: Number
  },
  methods: {
    async init() {
      if (this.raceId) {
        this.race = await this.$store.dispatch('race/byId', this.raceId);
        this.load();
      }
    },
    async load() {
      let results = await this.$User.service.getRaceLeagueStandings(
        this.raceId
      );
    }
  },
  mounted() {
    this.init();
  },
  computed: {}
};
</script>

<style>
</style>